import { useEffect, useState } from 'react';
import { isE2eMode, reauthenticateE2eSession } from '~/lib/e2eAuth';

type Props = { children: React.ReactNode };

export function RequireAuth({ children }: Props) {
  const [status, setStatus] = useState<
    'checking' | 'authed' | 'unauthenticated'
  >('checking');

  useEffect(() => {
    let cancelled = false;

    async function check() {
      try {
        const res = await fetch('/auth/me', {
          method: 'GET',
          credentials: 'include',
          headers: { Accept: 'application/json' },
        });

        if (cancelled) return;

        if (res.ok) {
          const redirect = sessionStorage.getItem('post_login_redirect');
          sessionStorage.removeItem('post_login_redirect');
          if (redirect && /^\/[^/]/.test(redirect)) {
            window.location.replace(redirect);
            return;
          }
          setStatus('authed');
          return;
        }

        await redirectToLogin();
      } catch (e) {
        if (cancelled) return;
        console.error(e);
        await redirectToLogin();
      }
    }

    async function redirectToLogin() {
      if (isE2eMode) {
        if (await reauthenticateE2eSession()) {
          if (!cancelled) setStatus('authed');
          return;
        }
        if (!cancelled) setStatus('unauthenticated');
        return;
      }
      sessionStorage.setItem(
        'post_login_redirect',
        window.location.pathname + window.location.search
      );
      window.location.assign(`/oauth2/authorization/cognito`);
    }

    check();

    return () => {
      cancelled = true;
    };
  }, []);

  if (status === 'checking') return <div>Checking session…</div>;
  if (status === 'unauthenticated') return <div>Session expired.</div>;

  return <>{children}</>;
}
